import { Model, attr } from 'redux-orm';
import { createAction, createRequestConst } from '../util';

export default class Paynet extends Model {
  static get modelName() {
    return 'Paynet';
  }

  static reducer({ type, data }, Paynet) {
    switch (type) {
      case LOAD.SUCCESS:
        Paynet.delete();
        data?.response?.forEach((r) => {
          Paynet.create(r);
        });
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      createdAt: attr(),
      href: attr(),
      id: attr(),
      insAdminUserId: attr(),
      insUser: attr(),
      insUserId: attr(),
      name: attr(),
      offset: attr(),
      updAdminUserId: attr(),
      updUser: attr(),
      updUserId: attr(),
      updatedAt: attr(),
    };
  }
}

export const LOAD = createRequestConst(Paynet.modelName);

export const load = createAction(LOAD);
